import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UserService} from 'src/app/services/user.service';
import {Err} from '../../../err';
import {NotificationService} from '../../../services/notification.service';
import EMAIL_REGEX from '../../../validators/regex/email.regex';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  message = '';
  isLoading = false;
  showCheckPasswordError: boolean;
  usernameAvailable = true;
  userActivated = false;

  howDidYouFindUsOptions = [
    {value: 0, label: 'Vrienden, familie, kennissen of collega\'s'},
    {value: 1, label: 'Rechtbank'},
    {value: 2, label: 'Flyers'},
    {value: 3, label: 'Zoekresultaten'},
    {value: 4, label: 'Advertenties'},
    {value: 5, label: 'Social Media'},
    {value: 6, label: 'Geen van deze antwoorden'}
  ];

  constructor(private builder: FormBuilder,
              private service: UserService,
              private notificationService: NotificationService,
              private router: Router) {
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    if (this.service.isLoggedIn()) {
      this.router.navigate(['/']);
    }
    this.form = this.getForm();
  }

  register(value) {
    this.submitted = true;

    if (value.password !== value.password2) {
      this.showCheckPasswordError = true;
      this.notificationService.error('wachtwoorden komen niet overeen');
      return;
    } else {
      this.showCheckPasswordError = false;
    }

    if (this.form.invalid || this.isLoading) {
      return;
    }

    this.isLoading = true;

    this.service.register(value).subscribe(userId => {
      this.router.navigate(['/activatie/' + userId]);
      this.form = this.getForm();
      this.isLoading = false;
    }, response => {
      this.message = Err[response.error.message];
      this.isLoading = false;
    });
  }

  checkForEmail($event: Event) {
    const email = ($event.target as HTMLInputElement).value;
    if (email.match(EMAIL_REGEX)) {
      this.service.isUsernameAvailable(email).subscribe(res => {
        this.usernameAvailable = res.usernameAvailable;
        this.userActivated = res.userActivated;
      });
    } else {
      this.usernameAvailable = true;
    }
  }

  send(action: string) {
    if (this.isLoading) {
      return;
    }
    const username = {email: this.form.value.username};
    const promise = action === 'PasswordRecoveryMail' ?
      this.service.recover(username) :
      this.service.sendActivationMail(username);
    promise.subscribe(() => {
      this.notificationService.success('er is een e-mail met meer informatie verzonden');
      this.router.navigate(['/login']);
    }, response => {
      this.message = Err[response.error.message];
    });
  }

  private getForm() {
    return this.builder.group({
      'username': ['', [Validators.required, Validators.pattern(EMAIL_REGEX), Validators.maxLength(255)]],
      'firstNameInitials': ['', [Validators.required, Validators.maxLength(255)]],
      'firstName': ['', [Validators.required, Validators.maxLength(255)]],
      'insertion': ['', [Validators.maxLength(255)]],
      'lastName': ['', [Validators.required, Validators.maxLength(255)]],
      'street': ['', [Validators.required, Validators.maxLength(255)]],
      'houseNumber': ['', [Validators.required, Validators.maxLength(255)]],
      'houseNumberSuffix': ['', [Validators.maxLength(255)]],
      'zipCode': ['', [Validators.required, Validators.maxLength(255)]],
      'city': ['', [Validators.required, Validators.maxLength(255)]],
      'phone': ['', [Validators.required, Validators.maxLength(255)]],
      'password': ['', [Validators.required, Validators.minLength(6)]],
      'password2': ['', [Validators.required, Validators.minLength(6)]],
      'agreed': [false, Validators.requiredTrue],
      'howDidYouFindUs': [null]
    });
  }
}
